<template>
  <div
    class="card mt-2 ml-3"
    style="box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
    <div class="card-body pt-2 pl-2 pr-2 pb-1">
      <div class="row">
        <div
          v-for="(colors, key) of allColors"
          :key="key"
          @click="setColor(key)"
          class="col-2 m-0 p-0 pb-1 color">
          <svg style="display: block; margin: auto" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="29" height="29" rx="16" :fill="`url(#paint_color_${colors[0]}`"/>
            <defs>
              <linearGradient :id="`paint_color_${colors[0]}`" x1="10" y1="0" x2="10" y2="20" gradientUnits="userSpaceOnUse">
                <stop :stop-color="`#${colors[0]}`"/>
                <stop :offset="1" :stop-color="`#${colors[1]}`"/>
              </linearGradient>
            </defs>
          </svg>
          <i class="fe font-weight-bold fe-check hovered"></i>
          <i
            v-if="colors[0] === selectedColor[0]"
            class="fe font-weight-bold fe-check"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import projectColors from "../../configs/projectColors";
  export default {
    name: "EditProjectSelectColor",
    props: {
      project: {
        default: function () {
          return {}
        }
      }
    },
    computed: {
      selectedColor: function () {
        if (!this.project.color) {
          this.$set(this.project, 'color', 0)
        }
        return projectColors[this.project.color] ? projectColors[this.project.color] : ['D62121', 'FB6B6B'];
      },
      allColors: function () {
        return projectColors
      }
    },
    methods: {
      setColor: function (color) {
        this.$emit('newColor', color);
      }
    }
  }
</script>

<style scoped>
  .card {
    position: relative;
    left: 0;
  }
    .color {
      cursor: pointer;
    }

      .hovered {
        opacity: 0;
        transition-duration: .2s;
      }

      i {
        display: block;
        position: absolute;
        top: 17%;
        left: 29%;
        color: white;
      }

    .color:hover .hovered{
      transition-duration: .2s;
      opacity: .5;
    }

</style>
